import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { Checkbox, FormControl } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';



class MultipleSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isPulldownOpen: false,
        }
    }

    handleOpen = () => {
        this.setState({isPulldownOpen: true});
    }
    
    handleClose = () => {
        this.setState({isPulldownOpen: false});
    }

    render() {
        const CustomFormControl = styled(FormControl)({
            ...this.props.formControlStyle
        })
        const CustomSelect = styled(Select)({
            ...this.props.selectStyle,
            textOverflow: "ellipsis",
        })
        return (
            <CustomFormControl disabled = {this.props.disable}>
                <CustomSelect
                    multiple
                    value={this.props.value}
                    onChange={this.props.onChange}
                    onOpen={this.handleOpen}
                    onClose={this.handleClose}
                    open={this.state.isPulldownOpen}
                    renderValue={(selected)=>selected.map((index) => this.props.array[index]).join(', ')}
                    disableUnderline
                >
                    {
                        Object.keys(this.props.array).map((index) => (
                            <MenuItem key={index} value={index}>
                                <Checkbox color="primary" checked={this.props.value.indexOf(index) > -1}/>
                                <ListItemText primary={this.props.array[index]}/>
                            </MenuItem>
                        ))
                    }
                </CustomSelect>
            </CustomFormControl>
        )
    }
}

export { MultipleSelect };

MultipleSelect.propTypes = {
    array: PropTypes.object.isRequired,
    formControlStyle: PropTypes.object,
    selectStyle: PropTypes.object,
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    disable: PropTypes.bool.isRequired,
};